export const inputStyle: React.CSSProperties = { padding: "8px", margin: "0" };
export const errMsgFocusStyle: React.CSSProperties = { outline: "1px solid rgba(239, 68, 68, 0.5)" };
export const WORK_EMAIL_REGEX = /^(?!.+@(gmail|yahoo|hotmail|yahoo|aol|abc|xyz|pqr|rediffmail|live|outlook|me|msn|ymail)\..+)(.+@.+\..+)$/i;
export const LINKED_IN_URL = /\b((http|https):\/\/)?(www\.)?linkedin\.com\/in\/[a-zA-Z0-9_-]+\/?\b/;
export const verifyPhoneNumber = (text: string): boolean => {
    let isPhnNo = false;
    if (text.length > 15) return false;
    if (text.length === 0) return true;
    for (let i = 0; i < text.length; i++) {
        const ascii = text.charCodeAt(i);
        if ((ascii >= 48 && ascii <= 57) || (ascii === 43 && i === 0)) {
            isPhnNo = true;
        } else {
            return false;
        }
    }
    return isPhnNo;
};
